import { client } from '../common/client';
import type { GetShippingPoliciesResponse, GetShippingPolicyRequest, GetShippingPolicyResponse } from './utils/types';

/**
 * API client for site configuration operations
 */
class SiteconfigAPIClient {
  /**
   * Fetch all shipping policies
   * @returns Promise with shipping policies data
   */
  public async getShippingPolicies(): Promise<GetShippingPoliciesResponse> {
    return await client.get('/shippingPolicies').then((res) => res.data);
  }

  /**
   * Fetch shipping policy by currency
   * @param params Request params with currency
   * @returns Promise with shipping policy data
   */
  public async getShippingPolicy(params: GetShippingPolicyRequest): Promise<GetShippingPolicyResponse> {
    return await client.get('/shippingPolicy', { params }).then((res) => res.data);
  }
}

export const siteconfigAPIClient = new SiteconfigAPIClient();
